import { pipelineChangeDetectionLegend, pipelineGreenLegend } from '../config/legends'

const service =  {
    name: 'PipelineViewer',
    label: 'Pipeline Viewer',
    permissionId: 'pipelineviewer',
    iconComponent: 'Pipeline',
  showCoordinates: true,
  hideDatetimeSlider: true,
  disableMainDate: true,
  showDissolveClock: true,
  data: [
  ],
  layers: [
    // {
    //   name: 'Sentinel1Arctic',
    //   label: 'Sentinel 1 (75 m)',
    //   opacity: 'raster-opacity',
    //   datetimeId: 'Sentinel1Arctic',
    //   secondary: true
    // },
    {
      name: 'Sentinel2Pipeline',
      label: 'Sentinel 2',
      opacity: 'raster-opacity',
      datetimeId: 'Sentinel2Pipeline',
      secondary: true,
      hidden: false,
      open: true
    },
    {
      name: 'Sentinel1Pipeline',
      label: 'Sentinel 1',
      opacity: 'raster-opacity',
      datetimeId: 'Sentinel1Pipeline',
      secondary: true,
      hidden: false,
      open: true
    },
    // {
    //   name: 'PipelineBasic',
    //   label: 'Analysis',
    //   opacity: 'raster-opacity',
    //   datetimeId: 'PipelineGreen',
    //   open: true,
    //   legend: {
    //     type: 'categorical',
    //     data: pipelineGreenLegend
    //   }
    // },
    // {
    //   name: 'PipelineGreen',
    //   label: 'Analysis',
    //   opacity: 'raster-opacity',
    //   datetimeId: 'PipelineGreen',
    //   hidden: true,
    //   legend: {
    //     type: 'categorical',
    //     data: pipelineGreenLegend
    //   }
    // },
    {
      name: 'EnbridgePipeline',
      label: 'Enbridge Pipeline',
      opacity: 'vector-opacity',
      hidden: true,
    },
    ],
  locations: [
    {
      name: 'MackinawCity',
      label: 'Mackinaw City',
      latitude: 45.783889,
      longitude: -84.7278,
      maxBounds: [[-150, -85], [80, 85]],
      zoom: [13]
    }
    ]
}

export default service



// WEBPACK FOOTER //
// ./src/services/PipelineViewer.js